export enum ProductType {
  sportsbook = 'sportsbook',
  casino = 'casino'
}
